import { ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="mt-8 text-center space-y-4">
      <div className="flex flex-col items-center gap-3">
        <div className="text-sm font-medium text-gray-700">Explore Global Salary Calculators</div>
        <div className="flex flex-wrap justify-center gap-3 text-sm">
          <span className="px-2 py-1 bg-blue-50 rounded-full text-blue-700 border border-blue-100">
            India
          </span>
          <a 
            href="https://paycheckcalc.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-2 py-1 bg-gray-50 hover:bg-gray-100 rounded-full text-gray-700 hover:text-blue-700 border border-gray-200 transition-colors duration-200"
            aria-label="Visit PaycheckCalc.com for US calculators"
          >
            <span>US</span>
            <ExternalLink className="w-3 h-3 ml-1" aria-hidden="true" />
          </a>
          <a 
            href="https://paycheckcalc.com/international/uk" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-2 py-1 bg-gray-50 hover:bg-gray-100 rounded-full text-gray-700 hover:text-blue-700 border border-gray-200 transition-colors duration-200"
            aria-label="Visit PaycheckCalc UK calculator"
          >
            <span>UK</span>
            <ExternalLink className="w-3 h-3 ml-1" aria-hidden="true" />
          </a>
          <a 
            href="https://paycheckcalc.com/international/canada" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center px-2 py-1 bg-gray-50 hover:bg-gray-100 rounded-full text-gray-700 hover:text-blue-700 border border-gray-200 transition-colors duration-200"
            aria-label="Visit PaycheckCalc Canada calculator"
          >
            <span>Canada</span>
            <ExternalLink className="w-3 h-3 ml-1" aria-hidden="true" />
          </a>
        </div>
      </div>
      <p className="text-sm text-gray-500">
        &copy; {new Date().getFullYear()} CTC Calculator. All calculations are for illustration purposes only.
      </p>
      <div className="text-xs text-gray-400 flex flex-wrap justify-center gap-x-4 gap-y-2">
        <Link to="/tax-history" className="hover:text-gray-600 hover:underline">
          Tax history archive
        </Link>
        <span>&bull;</span>
        <Link to="/privacy" className="hover:text-gray-600 hover:underline">
          Privacy Policy
        </Link>
        <span>&bull;</span>
        <Link to="/contact" className="hover:text-gray-600 hover:underline">
          Contact Us
        </Link>
      </div>
    </footer>
  );
} 
